import XkTagItem from './src/tagitem.vue'

XkTagItem.install = function (Vue) {
  Vue.component(XkTagItem.name, XkTagItem)
}

export default XkTagItem



// WEBPACK FOOTER //
// ./src/components/module/tagitem/index.js